import { baseService } from './baseService'
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
  toastKey,
} from '../utils/showToast'
class AddAdminService extends baseService {
  async add(payload) {
    try {
      showLoadingToast('Đang thực hiện thêm!', toastKey.SYSTEM.ADMINS.ADD)
      const data = {
        userId: payload.uuid,
      }
      const res = await this.post('admin', data)
      if (res?.status !== 200 || !res?.data?.data)
        showErrorToast(
          'Thêm quản trị viên thất bại!',
          toastKey.SYSTEM.ADMINS.ADD
        )
      showSuccessToast(
        'Thêm quản trị viên thành công!',
        toastKey.SYSTEM.ADMINS.ADD
      )
    } catch (error) {
      showErrorToast({
        message: 'Thêm quản trị viên thất bại!',
        error: error.message,
        toastId: toastKey.SYSTEM.ADMINS.ADD,
      })
    }
  }
}
export const addAdminService = new AddAdminService()
